import { render, staticRenderFns } from "./editBiker.vue?vue&type=template&id=6caf4d46&scoped=true&"
import script from "./editBiker.vue?vue&type=script&lang=js&"
export * from "./editBiker.vue?vue&type=script&lang=js&"
import style0 from "./editBiker.vue?vue&type=style&index=0&id=6caf4d46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf4d46",
  null
  
)

export default component.exports